export const PulsingPill = ({ className }: { className?: string }) => (
  <span className={className}>
    <div className='absolute w-full h-full bg-blue-500 rounded-full' />
    <div className='w-full h-full bg-blue-500 rounded-full animate-ping' />
  </span>
)
